import { useGlobalStore } from '@highlight/ipc/react'
import { StoreSafeObject } from '@highlight/ipc'

export const useLdFlag = <T extends StoreSafeObject>(key: string, defaultValue: StoreSafeObject) => {
  const [value] = useGlobalStore<T>('flags', key, defaultValue)
  return value
}
